
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { AuthHttp } from '../../admin/services/token.service';
// import { AppConstant } from './../../shared/constant/app.constant';
import { Injectable } from '@angular/core';


import { AppConfigService } from '../../shared/services/app.config.service';

let AppConstant: any = {};
@Injectable()
export class BulkRateService {
    constructor(private http: AuthHttp, private appConfigService: AppConfigService) {
        AppConstant = appConfigService;
    }

    getExcemptions() {
        return this.http.get(`operations/bulk-rate-customer-excemptions`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getNewInterestRateReviews() {
        return this.http.get(`operations/new-interest-rate-review`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    addLoanBulkRateExcemptions(formObj) {
        let bodyObj = JSON.stringify(formObj);
        return this.http.post(`operations/add-bulk-rate-excemption`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    
    addNewInterestRate(formObj) {
        let bodyObj = JSON.stringify(formObj);
        return this.http.post(`operations/interest-rate-change`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    applyBulkInterestRate(formObj) {
        let bodyObj = JSON.stringify(formObj);
        return this.http.post(`operations/bulk-interest-rate-change/application`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
  
}